import React, { useState } from "react";
import TradeCaseTabs from "../components/search/TradeCaseTabs";
import TradeCasesGrid from "../components/search/TradeCasesGrid";
import ItemGrid from "../components/search/ItemGrid";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { getUIProperty } from "../redux/slices/uiSlice";
import VendorsModal from "../components/generic/VendorsModal";
import Loader from "../components/generic/Loader";
import useResourceStatus from "../hooks/useResourceStatus";

const ResultsPage = () => {
  const [ready, setReady] = useState(true);
  const { searchDetailsStatus } = useResourceStatus();

  const showVendorModal = useSelector((state) =>
    getUIProperty(state, "showVendorModal")
  );

  return (
    <>
      {showVendorModal && <VendorsModal />}

      <Grid container direction="column" spacing={3}>
        <Grid item xs={12}>
          <TradeCasesGrid />
        </Grid>
        <Grid item>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
            spacing={5}
          >
            <Grid item xs={5}>
              <Grid container spacing={2}>
                <Grid item style={{ width: "100%" }}>
                  <TradeCaseTabs />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={7} style={{ position: "relative" }}>
              {(!ready || searchDetailsStatus === "pending") && (
                <Loader style={{ width: "90%" }} />
              )}
              <ItemGrid setReady={setReady} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ResultsPage;
